import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import ExpandLessOutlinedIcon from '@mui/icons-material/ExpandLessOutlined';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import TimelineOutlinedIcon from '@mui/icons-material/TimelineOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';

import { Box, Drawer, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Menu, MenuItem, ProSidebar } from 'react-pro-sidebar';
import 'react-pro-sidebar/dist/css/styles.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getUser } from '../../services/authService';
import { tokens } from '../../theme';
import axios from '../../utils/axiosInstance'; // axios 가져오기

const Item = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return title === '' ? (
    <MenuItem
      active={selected === title}
      style={{
        color: '#fff',
        margin: '4px 0',
        borderRadius: '8px',
        transition: 'all 0.3s ease',
      }}
      onClick={() => alert('준비중입니다.')}
      icon={icon}
    >
      <Typography>{title}</Typography>
    </MenuItem>
  ) : (
    <MenuItem
      active={selected === title}
      style={{
        color: '#fff',
        margin: '4px 0',
        borderRadius: '8px',
        transition: 'all 0.3s ease',
      }}
      onClick={() => setSelected(title)}
      icon={icon}
    >
      <Typography>{title}</Typography>
      <Link to={to} />
    </MenuItem>
  );
};

const Sidebar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [selected, setSelected] = useState('');

  // 데이터 상태 - NextGate 추가
  const [isLoading, setIsLoading] = useState(true);
  const [gameVenderData, setGameVenderData] = useState({
    HONORLINK: 0,
    THENUTS: 0,
    AXE: 0,
    RAVE: 0,
    HIVE_STAR: 0,
    'THE A': 0,
    DEVAPLAY: 0,
    NEXTGATE: 0  // 🔥 NEXTGATE 추가
  });
  
  // 에이전트 데이터 상태
  const [agentData, setAgentData] = useState({
    cur_point: 0
  });

  const getBalanceColor = (value) => {
    if (value > 1000000) return '#4ade80'; // 큰 금액은 녹색
    if (value > 100000) return '#fbbf24';  // 중간 금액은 노란색
    return '#f87171';  // 작은 금액은 빨간색
  };
  
  const location = useLocation();

  // 그룹 상태 관리
  const [gameSettingsOpen, setGameSettingsOpen] = useState(false);
  const [userOpen, setUserOpen] = useState(false);
  const [gameVenderOpen, setGameVenderOpen] = useState(false);
  const [agentOpen, setAgentOpen] = useState(false);
  const [statsOpen, setStatsOpen] = useState(false);
  const [moneyOpen, setMoneyOpen] = useState(false);
  const [apiOpen, setApiOpen] = useState(false);

  const navigate = useNavigate();
  
  // 라우트 감지 및 메뉴 설정
  useEffect(() => {
    const lastSegment = location.pathname.split('/').filter(Boolean).pop();

    // lastSegment 값에 따라 selected 값을 설정
    switch (lastSegment) {
      case undefined:
        setSelected('대시보드');
        break;
      case 'my':
        setSelected('마이페이지');
        break;
      case 'bet-limit':
        setSelected('최대 배팅 금액 제한');
        setGameSettingsOpen(true);
        break;
      case 'win-limit':
        setSelected('최대 당첨 금액 제한');
        setGameSettingsOpen(true);
        break;
      case 'enabled':
        setSelected('게임사 사용 여부');
        setGameSettingsOpen(true);
        break;
      case 'game-enabled':
        setSelected('게임 사용 여부');
        setGameSettingsOpen(true);
        break;
      case 'transfer':
        setSelected('트랜스퍼 (분리형 지갑)');
        setApiOpen(true);
        break;
      case 'seamless':
        setSelected('심리스 (통합형 지갑)');
        setApiOpen(true);
        break;
      case 'error':
        setSelected('API 에러');
        setApiOpen(true);
        break;
      case 'user-bet':
        setSelected('배팅 내역');
        setUserOpen(true);
        break;
      case 'transaction':
        setSelected('트랜잭션 내역');
        setUserOpen(true);
        break;
      case 'user-list':
        setSelected('유저 목록');
        setUserOpen(true);
        break;
      case 'money':
        setSelected('지급 내역');
        setUserOpen(true);
        break;
      case 'agent-transaction':
        setSelected('트랜잭션 목록');
        setAgentOpen(true);
        break;
      case 'agent-list':
        setSelected('에이전트 목록');
        setAgentOpen(true);
        break;
      case 'statistic-agent':
        setSelected('에이전트별 수익 통계');
        setStatsOpen(true);
        break;
      case 'statistic-each-vender':
        setSelected('벤더별 수익 통계');
        setStatsOpen(true);
        break;
      case 'statistic-vender':
        setSelected('게임사별 수익 통계');
        setStatsOpen(true);
        break;
      case 'statistic-user':
        setSelected('유저 수익 통계');
        setStatsOpen(true);
        break;
      case 'money-day':
        setSelected('일자별 통계');
        setMoneyOpen(true);
        break;
      case 'money-charge-history':
        setSelected('충전 내역');
        setMoneyOpen(true);
        break;
      case 'money-send-history':
        setSelected('지급해준 내역');
        setMoneyOpen(true);
        break;
      case 'money-reveive-history':
        setSelected('지급받은 내역');
        setMoneyOpen(true);
        break;
      case 'money-payment-history':
        setSelected('수기지급 받은 내역');
        setMoneyOpen(true);
        break;
      case 'game-vender':
        setSelected('게임사 벤더 설정');
        setGameVenderOpen(true);
        break;
    }

    // 스크롤을 최상단으로 부드럽게 이동
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location]);

  // API에서 데이터 가져오기 - NextGate 추가
  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        
        // 현재 사용자의 역할 확인
        const currentUser = getUser();
        const isAdmin = currentUser?.grade === 'admin';
        
        if (isAdmin) {
          // 관리자인 경우 - 게임사 정보 가져오기
          // console.log('관리자 데이터 로딩 시작');
          
          try {
            const response = await axios.get('/info');
            console.log('API 응답 데이터:', response.data);
            
            if (response.data && response.data.success) {
              const { info } = response.data;
              const mappedData = {
                HONORLINK: info.honorlink?.data?.balance || 0,
                THENUTS: info.thenuts?.data?.balance || 0,
                AXE: info.axegames?.data?.balance || 0,
                RAVE: info.rave?.data?.balance || 0,
                HIVE_STAR: info.hive_star?.data?.balance || 0,
                'THE A': info.the_a?.data?.balance || 0,
                DEVAPLAY: info.devaplay?.data?.balance || 0,
                NEXTGATE: info.next_gate?.data?.balance || 0  // 🔥 NEXTGATE 추가
              };
              
              console.log('매핑된 데이터:', mappedData);
              setGameVenderData(mappedData);
            }
          } catch (error) {
            console.error('게임사 정보 가져오기 실패:', error);
            // 에러시 기본값 유지
          }
        } else {
          // 에이전트인 경우 - 에이전트 데이터 가져오기
          // console.log('에이전트 데이터 로딩 시작');
          
          // 현재 에이전트 ID 가져오기
          // 현재 에이전트 ID 가져오기
          const agentId = currentUser?.id;
          if (agentId) {
            try {
              const response = await axios.get(`/agent/info/${agentId}`);
              console.log('에이전트 API 응답 데이터:', response.data);
              
              if (response.data && response.data.success) {
                // agent 객체에서 cur_point 가져오기 (admin이 아님)
                const pointValue = response.data.agent?.cur_point || "0";
                setAgentData({
                  cur_point: parseInt(pointValue, 10)
                });
                
                console.log('설정된 에이전트 잔액:', parseInt(pointValue, 10));
              }
            } catch (error) {
              console.error('에이전트 정보 가져오기 실패:', error);
              // 에러시 0으로 설정
              setAgentData({ cur_point: 0 });
            }
          } 
        }
      } catch (error) {
        console.error('데이터 로딩 중 오류 발생:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
    
    // 30초마다 데이터 갱신
    const intervalId = setInterval(fetchData, 30000);
    
    return () => clearInterval(intervalId);
  }, []);

  // 모바일 여부 확인
  const isMobile = useMediaQuery('(max-width: 768px)');

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  // 메뉴 그룹 헤더 스타일 공통 함수
  const getMenuHeaderStyle = (isOpen) => ({
    cursor: 'pointer', 
    px: 2.5, 
    py: 1.5, 
    mt: 1.5,
    mb: 0.5,
    borderRadius: '8px',
    background: isOpen ? 'rgba(255, 255, 255, 0.1)' : 'rgba(255, 255, 255, 0.05)',
    transition: 'all 0.3s ease',
    '&:hover': {
      background: 'rgba(255, 255, 255, 0.15)',
    },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  });

  // 현재 사용자가 관리자인지 확인
  const isAdmin = getUser()?.grade === 'admin';

  // 현재 잔액 정보 렌더링
  const renderBalanceInfo = () => {
    // if (isLoading) {
    //   return (
    //     <Typography variant="body2" align="center" sx={{ py: 2, color: 'rgba(255,255,255,0.7)' }}>
    //       데이터 로딩 중...
    //     </Typography>
    //   );
    // }

    if (isAdmin) {
      // 관리자용 게임사 잔액 정보
      return Object.entries(gameVenderData).map(([label, value], index) => (
        <Box
          key={label}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          py={1.4}
          px={1}
          mb={1}
          sx={{
            borderRadius: '10px',
            background: 'rgba(255, 255, 255, 0.05)',
            backdropFilter: 'blur(5px)',
            transition: 'all 0.3s ease',
            '&:hover': {
              background: 'rgba(255, 255, 255, 0.1)',
              transform: 'translateY(-2px)',
              boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
            }
          }}
        >
          <Typography 
            variant="body1" 
            fontWeight="600" 
            sx={{ 
              fontSize: '16px',
              color: '#fff',
              opacity: 0.9,
              letterSpacing: '0.3px'
            }}
          >
            {label}
          </Typography>
          <Typography 
            variant="body1" 
            fontWeight="700" 
            sx={{ 
              color: getBalanceColor(value),
              fontSize: '18px',
              textShadow: '0 1px 2px rgba(0,0,0,0.3)',
              fontFamily: 'Roboto, sans-serif',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
          >
            <span>{value.toLocaleString()}</span>
            <span style={{ fontSize: '14px', opacity: 0.7 }}>원</span>
          </Typography>
        </Box>
      ));
    } else {
      // 에이전트용 잔액 정보
      return (
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          py={1.8}
          px={1.5}
          mb={1}
          sx={{
            borderRadius: '10px',
            background: 'rgba(255, 255, 255, 0.08)',
            backdropFilter: 'blur(5px)',
            transition: 'all 0.3s ease',
            '&:hover': {
              background: 'rgba(255, 255, 255, 0.12)',
              transform: 'translateY(-2px)',
              boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
            }
          }}
        >
          <Box display="flex" alignItems="center" gap={1.5}>
            <AccountBalanceWalletOutlinedIcon sx={{ color: '#fff', fontSize: 28 }} />
            <Typography 
              variant="body1" 
              fontWeight="600" 
              sx={{ 
                fontSize: '17px',
                color: '#fff',
                opacity: 0.95,
                letterSpacing: '0.3px'
              }}
            >
              잔액
            </Typography>
          </Box>
          <Typography 
            variant="body1" 
            fontWeight="700" 
            sx={{ 
              color: getBalanceColor(agentData.cur_point),
              fontSize: '20px',
              textShadow: '0 1px 2px rgba(0,0,0,0.3)',
              fontFamily: 'Roboto, sans-serif',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
          >
            <span>{agentData.cur_point.toLocaleString()}</span>
            <span style={{ fontSize: '14px', opacity: 0.7 }}>원</span>
          </Typography>
        </Box>
      );
    }
  };

  // Sidebar Content
  const sidebarContent = (
    <Box
      sx={{
        '& .pro-sidebar-inner': {
          background: 'linear-gradient(145deg, rgba(25,25,38,0.95) 0%, rgba(25,32,48,0.95) 100%) !important',
          boxShadow: 'inset -1px 0 0 rgba(255, 255, 255, 0.1)',
          backdropFilter: 'blur(12px)',
        },
        '& .pro-icon-wrapper': {
          backgroundColor: 'transparent !important',
        },
        '& .pro-inner-item': {
          padding: '8px 16px 8px 20px !important',
          transition: 'all 0.3s ease',
        },
        '& .pro-inner-item:hover': {
          color: '#fff !important',
          background: 'rgba(255, 255, 255, 0.1)',
          borderRadius: '8px',
        },
        '& .pro-menu-item.active': {
          background: 'rgba(104, 117, 245, 0.2)',
          borderRadius: '8px',
          '& .pro-inner-item': {
            color: '#fff !important',
          }
        },
        '& .pro-menu': {
          padding: '16px 12px',
        },
        '& .pro-sidebar-content': {
          background: 'transparent',
        }
      }}
    >
      <ProSidebar collapsed={isCollapsed}>
        <Menu iconShape="square">
          {/* LOGO AND MENU ICON */}
          <MenuItem
            onClick={() => setIsCollapsed(!isCollapsed)}
            icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
            style={{
              margin: '10px 0 20px 0',
              color: '#fff',
              background: 'transparent',
            }}
          >
            {!isCollapsed && (
              <Box display="flex" justifyContent="space-between" alignItems="center" ml="15px">
                <Typography variant="h3" sx={{ color: '#fff', fontWeight: 'bold', letterSpacing: '1px' }}>
                  ADMINIS
                </Typography>
                {!isMobile && (
                  <IconButton onClick={() => setIsCollapsed(!isCollapsed)} sx={{ color: '#fff' }}>
                    <MenuOutlinedIcon />
                  </IconButton>
                )}
              </Box>
            )}
          </MenuItem>

          {!isCollapsed && (
          <Box mb="25px" display="flex" justifyContent="center" alignItems="center">
            <Box textAlign="center">
              <Typography 
                variant="h2" 
                sx={{ 
                  color: '#fff', 
                  fontWeight: 'bold', 
                  m: '10px 0 0 0', 
                  letterSpacing: '0.5px',
                  cursor: 'pointer', // 커서를 포인터로 변경하여 클릭 가능함을 표시
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    textShadow: '0 0 8px rgba(255, 255, 255, 0.5)', // 호버 효과 추가
                    transform: 'scale(1.02)' // 약간 확대 효과 추가
                  }
                }}
                onClick={() => {
                  // 페이지를 새로고침하고 대시보드로 이동
                  navigate('/');
                  window.location.reload();
                }}
              >
                {isAdmin ? '관리자' : '에이전트'}
              </Typography>
              <Box
                sx={{
                  borderRadius: '16px',
                  padding: '22px',
                  width: '300px',
                  background: 'linear-gradient(145deg, rgba(30,30,45,0.9) 0%, rgba(30,40,60,0.85) 100%)',
                  boxShadow: '0 10px 20px rgba(0, 0, 0, 0.2), 0 6px 6px rgba(0, 0, 0, 0.15)',
                  margin: '15px 0',
                  border: '1px solid rgba(255, 255, 255, 0.12)',
                  backdropFilter: 'blur(12px)',
                  cursor: 'pointer', // 커서를 포인터로 변경
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    boxShadow: '0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22)', // 호버 시 그림자 강화
                    transform: 'translateY(-3px)' // 약간 위로 이동하는 효과
                  }
                }}
                onClick={() => {
                  // 페이지를 새로고침하고 대시보드로 이동
                  navigate('/');
                  window.location.reload();
                }}
              >
                <Typography 
                  variant="h6" 
                  align="center" 
                  fontWeight="bold" 
                  gutterBottom
                  sx={{ 
                    color: '#fff', 
                    borderBottom: '1px solid rgba(255, 255, 255, 0.2)', 
                    pb: 1.5,
                    fontSize: '20px',
                    letterSpacing: '0.8px',
                    textTransform: 'uppercase',
                    marginBottom: '16px',
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                  }}
                >
                  {isAdmin ? '실시간 현황' : '계정 현황'}
                </Typography>

                {renderBalanceInfo()}
              </Box>
            </Box>
          </Box>
        )}

          {/* Menu Items */}
          <Box paddingLeft={isCollapsed ? undefined : '8px'} sx={{ mt: 2 }}>
            <Box
              sx={{
                borderRadius: '10px',
                background: selected === '대시보드' ? 'rgba(104, 117, 245, 0.2)' : 'transparent',
                transition: 'all 0.3s ease',
                mb: 1,
                '&:hover': {
                  background: 'rgba(255, 255, 255, 0.1)',
                }
              }}
            >
              <Item title="대시보드" to="/" icon={<HomeOutlinedIcon />} selected={selected} setSelected={setSelected} />
            </Box>

            {getUser()?.grade !== 'admin' && (
              <Box
                sx={{
                  borderRadius: '10px',
                  background: selected === '마이페이지' ? 'rgba(104, 117, 245, 0.2)' : 'transparent',
                  transition: 'all 0.3s ease',
                  mb: 1,
                  '&:hover': {
                    background: 'rgba(255, 255, 255, 0.1)',
                  }
                }}
              >
                <Item title="마이페이지" to="/my" icon={<PersonOutlinedIcon />} selected={selected} setSelected={setSelected} />
              </Box>
            )}

            {/* 게임 설정 그룹 */}
            <Box sx={{ mt: 3 }}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                onClick={() => setGameSettingsOpen(!gameSettingsOpen)}
                sx={getMenuHeaderStyle(gameSettingsOpen)}
              >
                <Typography sx={{ color: '#fff', fontSize: '16px', fontWeight: '600', letterSpacing: '0.5px' }}>
                  게임설정
                </Typography>
                {gameSettingsOpen ? 
                  <ExpandLessOutlinedIcon sx={{ color: '#fff' }} /> : 
                  <ExpandMoreOutlinedIcon sx={{ color: '#fff' }} />
                }
              </Box>
              {gameSettingsOpen && (
                <Box sx={{ ml: 1, mt: 1 }}>
                  {getUser()?.grade !== 'admin' && (
                    <Box
                      sx={{
                        borderRadius: '10px',
                        background: selected === '최대 배팅 금액 제한' ? 'rgba(104, 117, 245, 0.2)' : 'transparent',
                        transition: 'all 0.3s ease',
                        mb: 1,
                        '&:hover': {
                          background: 'rgba(255, 255, 255, 0.1)',
                        }
                      }}
                    >
                      <Item title="최대 배팅 금액 제한" to="/bet-limit" icon={<ReceiptOutlinedIcon />} selected={selected} setSelected={setSelected} />
                    </Box>
                  )}
                  {getUser()?.grade !== 'admin' && (
                    <Box
                      sx={{
                        borderRadius: '10px',
                        background: selected === '최대 당첨 금액 제한' ? 'rgba(104, 117, 245, 0.2)' : 'transparent',
                        transition: 'all 0.3s ease',
                        mb: 1,
                        '&:hover': {
                          background: 'rgba(255, 255, 255, 0.1)',
                        }
                      }}
                    >
                      <Item
                        title="최대 당첨 금액 제한"
                        to="/win-limit"
                        icon={<ReceiptOutlinedIcon />}
                        selected={selected}
                        setSelected={setSelected}
                      />
                    </Box>
                  )}
                  <Box
                    sx={{
                      borderRadius: '10px',
                      background: selected === '게임사 사용 여부' ? 'rgba(104, 117, 245, 0.2)' : 'transparent',
                      transition: 'all 0.3s ease',
                      mb: 1,
                      '&:hover': {
                        background: 'rgba(255, 255, 255, 0.1)',
                      }
                    }}
                  >
                    <Item title="게임사 사용 여부" to="/enabled" icon={<ReceiptOutlinedIcon />} selected={selected} setSelected={setSelected} />
                  </Box>
                  <Box
                    sx={{
                      borderRadius: '10px',
                      background: selected === '게임 사용 여부' ? 'rgba(104, 117, 245, 0.2)' : 'transparent',
                      transition: 'all 0.3s ease',
                      mb: 1,
                      '&:hover': {
                        background: 'rgba(255, 255, 255, 0.1)',
                      }
                    }}
                  >
                    <Item title="게임 사용 여부" to="/game-enabled" icon={<ReceiptOutlinedIcon />} selected={selected} setSelected={setSelected} />
                  </Box>
                </Box>
              )}
            </Box>

            {/* 유저 그룹 */}
            <Box sx={{ mt: 1 }}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                onClick={() => setUserOpen(!userOpen)}
                sx={getMenuHeaderStyle(userOpen)}
              >
                <Typography sx={{ color: '#fff', fontSize: '16px', fontWeight: '600', letterSpacing: '0.5px' }}>
                  유저
                </Typography>
                {userOpen ? 
                  <ExpandLessOutlinedIcon sx={{ color: '#fff' }} /> : 
                  <ExpandMoreOutlinedIcon sx={{ color: '#fff' }} />
                }
              </Box>
              {userOpen && (
                <Box sx={{ ml: 1, mt: 1 }}>
                  <Box
                    sx={{
                      borderRadius: '10px',
                      background: selected === '배팅 내역' ? 'rgba(104, 117, 245, 0.2)' : 'transparent',
                      transition: 'all 0.3s ease',
                      mb: 1,
                      '&:hover': {
                        background: 'rgba(255, 255, 255, 0.1)',
                      }
                    }}
                  >
                    <Item title="배팅 내역" to="/user-bet" icon={<CalendarTodayOutlinedIcon />} selected={selected} setSelected={setSelected} />
                  </Box>
                  <Box
                    sx={{
                      borderRadius: '10px',
                      background: selected === '트랜잭션 내역' ? 'rgba(104, 117, 245, 0.2)' : 'transparent',
                      transition: 'all 0.3s ease',
                      mb: 1,
                      '&:hover': {
                        background: 'rgba(255, 255, 255, 0.1)',
                      }
                    }}
                  >
                    <Item title="트랜잭션 내역" to="/transaction" icon={<CalendarTodayOutlinedIcon />} selected={selected} setSelected={setSelected} />
                  </Box>
                  <Box
                    sx={{
                      borderRadius: '10px',
                      background: selected === '유저 목록' ? 'rgba(104, 117, 245, 0.2)' : 'transparent',
                      transition: 'all 0.3s ease',
                      mb: 1,
                      '&:hover': {
                        background: 'rgba(255, 255, 255, 0.1)',
                      }
                    }}
                  >
                    <Item title="유저 목록" to="/user-list" icon={<CalendarTodayOutlinedIcon />} selected={selected} setSelected={setSelected} />
                  </Box>
                  <Box
                    sx={{
                      borderRadius: '10px',
                      background: selected === '지급 내역' ? 'rgba(104, 117, 245, 0.2)' : 'transparent',
                      transition: 'all 0.3s ease',
                      mb: 1,
                      '&:hover': {
                        background: 'rgba(255, 255, 255, 0.1)',
                      }
                    }}
                  >
                    <Item title="지급 내역" to="/money" icon={<CalendarTodayOutlinedIcon />} selected={selected} setSelected={setSelected} />
                  </Box>
                </Box>
              )}
            </Box>

            {/* 게임사 벤더 설정 그룹 */}
            {getUser()?.vendor_set == 'on' && (
              <Box sx={{ mt: 1 }}>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  onClick={() => setGameVenderOpen(!gameVenderOpen)}
                  sx={getMenuHeaderStyle(gameVenderOpen)}
                >
                  <Typography sx={{ color: '#fff', fontSize: '16px', fontWeight: '600', letterSpacing: '0.5px' }}>
                    게임사 벤더
                  </Typography>
                  {gameVenderOpen ? 
                    <ExpandLessOutlinedIcon sx={{ color: '#fff' }} /> : 
                    <ExpandMoreOutlinedIcon sx={{ color: '#fff' }} />
                  }
                </Box>
                {gameVenderOpen && (
                  <Box sx={{ ml: 1, mt: 1 }}>
                    <Box
                      sx={{
                        borderRadius: '10px',
                        background: selected === '게임사 벤더 설정' ? 'rgba(104, 117, 245, 0.2)' : 'transparent',
                        transition: 'all 0.3s ease',
                        mb: 1,
                        '&:hover': {
                          background: 'rgba(255, 255, 255, 0.1)',
                        }
                      }}
                    >
                      <Item
                        title="게임사 벤더 설정"
                        to="/game-vender"
                        icon={<CalendarTodayOutlinedIcon />}
                        selected={selected}
                        setSelected={setSelected}
                      />
                    </Box>
                  </Box>
                )}
              </Box>
            )}

            {/* 에이전트 그룹 */}
            <Box sx={{ mt: 1 }}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                onClick={() => setAgentOpen(!agentOpen)}
                sx={getMenuHeaderStyle(agentOpen)}
              >
                <Typography sx={{ color: '#fff', fontSize: '16px', fontWeight: '600', letterSpacing: '0.5px' }}>
                  에이전트
                </Typography>
                {agentOpen ? 
                  <ExpandLessOutlinedIcon sx={{ color: '#fff' }} /> : 
                  <ExpandMoreOutlinedIcon sx={{ color: '#fff' }} />
                }
              </Box>
              {agentOpen && (
                <Box sx={{ ml: 1, mt: 1 }}>
                  <Box
                    sx={{
                      borderRadius: '10px',
                      background: selected === '트랜잭션 목록' ? 'rgba(104, 117, 245, 0.2)' : 'transparent',
                      transition: 'all 0.3s ease',
                      mb: 1,
                      '&:hover': {
                        background: 'rgba(255, 255, 255, 0.1)',
                      }
                    }}
                  >
                    <Item
                      title="트랜잭션 목록"
                      to="/agent-transaction"
                      icon={<HelpOutlineOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />
                  </Box>
                  <Box
                    sx={{
                      borderRadius: '10px',
                      background: selected === '에이전트 목록' ? 'rgba(104, 117, 245, 0.2)' : 'transparent',
                      transition: 'all 0.3s ease',
                      mb: 1,
                      '&:hover': {
                        background: 'rgba(255, 255, 255, 0.1)',
                      }
                    }}
                  >
                    <Item title="에이전트 목록" to="/agent-list" icon={<HelpOutlineOutlinedIcon />} selected={selected} setSelected={setSelected} />
                  </Box>
                </Box>
              )}
            </Box>

            {/* 통계 그룹 */}
            <Box sx={{ mt: 1 }}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                onClick={() => setStatsOpen(!statsOpen)}
                sx={getMenuHeaderStyle(statsOpen)}
              >
                <Typography sx={{ color: '#fff', fontSize: '16px', fontWeight: '600', letterSpacing: '0.5px' }}>
                  통계
                </Typography>
                {statsOpen ? 
                  <ExpandLessOutlinedIcon sx={{ color: '#fff' }} /> : 
                  <ExpandMoreOutlinedIcon sx={{ color: '#fff' }} />
                }
              </Box>
              {statsOpen && (
                <Box sx={{ ml: 1, mt: 1 }}>
                  <Box
                    sx={{
                      borderRadius: '10px',
                      background: selected === '에이전트별 수익 통계' ? 'rgba(104, 117, 245, 0.2)' : 'transparent',
                      transition: 'all 0.3s ease',
                      mb: 1,
                      '&:hover': {
                        background: 'rgba(255, 255, 255, 0.1)',
                      }
                    }}
                  >
                    <Item
                      title="에이전트별 수익 통계"
                      to="/statistic-agent"
                      icon={<BarChartOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />
                  </Box>
                  {getUser()?.vendor_set == 'on' && (
                  <Box
                    sx={{
                      borderRadius: '10px',
                      background: selected === '벤더별 수익 통계' ? 'rgba(104, 117, 245, 0.2)' : 'transparent',
                      transition: 'all 0.3s ease',
                      mb: 1,
                      '&:hover': {
                        background: 'rgba(255, 255, 255, 0.1)',
                      }
                    }}
                  >
                    <Item
                      title="벤더별 수익 통계"
                      to="/statistic-each-vender"
                      icon={<BarChartOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />
                  </Box>
                  )}
                  <Box
                    sx={{
                      borderRadius: '10px',
                      background: selected === '게임사별 수익 통계' ? 'rgba(104, 117, 245, 0.2)' : 'transparent',
                      transition: 'all 0.3s ease',
                      mb: 1,
                      '&:hover': {
                        background: 'rgba(255, 255, 255, 0.1)',
                      }
                    }}
                  >
                    <Item
                      title="게임사별 수익 통계"
                      to="/statistic-vender"
                      icon={<BarChartOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />
                  </Box>
                  <Box
                    sx={{
                      borderRadius: '10px',
                      background: selected === '유저 수익 통계' ? 'rgba(104, 117, 245, 0.2)' : 'transparent',
                      transition: 'all 0.3s ease',
                      mb: 1,
                      '&:hover': {
                        background: 'rgba(255, 255, 255, 0.1)',
                      }
                    }}
                  >
                    <Item title="유저 수익 통계" to="/statistic-user" icon={<BarChartOutlinedIcon />} selected={selected} setSelected={setSelected} />
                  </Box>
                </Box>
              )}
            </Box>

            {/* 머니 유통 통계 그룹 */}
            <Box sx={{ mt: 1 }}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                onClick={() => setMoneyOpen(!moneyOpen)}
                sx={getMenuHeaderStyle(moneyOpen)}
              >
                <Typography sx={{ color: '#fff', fontSize: '16px', fontWeight: '600', letterSpacing: '0.5px' }}>
                  머니 유통 통계
                </Typography>
                {moneyOpen ? 
                  <ExpandLessOutlinedIcon sx={{ color: '#fff' }} /> : 
                  <ExpandMoreOutlinedIcon sx={{ color: '#fff' }} />
                }
              </Box>
              {moneyOpen && (
                <Box sx={{ ml: 1, mt: 1 }}>
                  <Box
                    sx={{
                      borderRadius: '10px',
                      background: selected === '일자별 통계' ? 'rgba(104, 117, 245, 0.2)' : 'transparent',
                      transition: 'all 0.3s ease',
                      mb: 1,
                      '&:hover': {
                        background: 'rgba(255, 255, 255, 0.1)',
                      }
                    }}
                  >
                    <Item title="일자별 통계" to="/money-day" icon={<TimelineOutlinedIcon />} selected={selected} setSelected={setSelected} />
                  </Box>
                  <Box
                    sx={{
                      borderRadius: '10px',
                      background: selected === '지급/회수 내역' ? 'rgba(104, 117, 245, 0.2)' : 'transparent',
                      transition: 'all 0.3s ease',
                      mb: 1,
                      '&:hover': {
                        background: 'rgba(255, 255, 255, 0.1)',
                      }
                    }}
                  >
                    <Item
                      title="지급/회수 내역"
                      to="/money-reveive-history"
                      icon={<TimelineOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />
                  </Box>
                </Box>
              )}
            </Box>

            {/* API 개발 그룹 */}
            <Box sx={{ mt: 1 }}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                onClick={() => setApiOpen(!apiOpen)}
                sx={getMenuHeaderStyle(apiOpen)}
              >
                <Typography sx={{ color: '#fff', fontSize: '16px', fontWeight: '600', letterSpacing: '0.5px' }}>
                  API 개발
                </Typography>
                {apiOpen ? 
                  <ExpandLessOutlinedIcon sx={{ color: '#fff' }} /> : 
                  <ExpandMoreOutlinedIcon sx={{ color: '#fff' }} />
                }
              </Box>
              {apiOpen && (
                <Box sx={{ ml: 1, mt: 1 }}>
                  <Box
                    sx={{
                      borderRadius: '10px',
                      background: selected === '트랜스퍼 (분리형 지갑)' ? 'rgba(104, 117, 245, 0.2)' : 'transparent',
                      transition: 'all 0.3s ease',
                      mb: 1,
                      '&:hover': {
                        background: 'rgba(255, 255, 255, 0.1)',
                      }
                    }}
                  >
                    <Item title="트랜스퍼 (분리형 지갑)" to="/transfer" icon={<BarChartOutlinedIcon />} selected={selected} setSelected={setSelected} />
                  </Box>
                  <Box
                    sx={{
                      borderRadius: '10px',
                      background: selected === '심리스 (통합형 지갑)' ? 'rgba(104, 117, 245, 0.2)' : 'transparent',
                      transition: 'all 0.3s ease',
                      mb: 1,
                      '&:hover': {
                        background: 'rgba(255, 255, 255, 0.1)',
                      }
                    }}
                  >
                    <Item title="심리스 (통합형 지갑)" to="/seamless" icon={<BarChartOutlinedIcon />} selected={selected} setSelected={setSelected} />
                  </Box>
                  <Box
                    sx={{
                      borderRadius: '10px',
                      background: selected === 'API 에러' ? 'rgba(104, 117, 245, 0.2)' : 'transparent',
                      transition: 'all 0.3s ease',
                      mb: 1,
                      '&:hover': {
                        background: 'rgba(255, 255, 255, 0.1)',
                      }
                    }}
                  >
                    <Item title="API 에러" to="/error" icon={<BarChartOutlinedIcon />} selected={selected} setSelected={setSelected} />
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
        </Menu>
      </ProSidebar>
    </Box>
  );

  return (
    <>
      {/* PC 화면 */}
      {!isMobile ? (
        sidebarContent
      ) : (
        // 모바일 화면
        <>
          <IconButton
            onClick={handleDrawerToggle}
            sx={{
              position: 'fixed',
              top: 17,
              left: 15,
              zIndex: 1300,
              color: '#fff',
            }}
          >
            <MenuOutlinedIcon />
          </IconButton>
          <Drawer
            anchor="left"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            sx={{
              '& .MuiDrawer-paper': {
                background: 'linear-gradient(145deg, rgba(25,25,38,0.95) 0%, rgba(25,32,48,0.95) 100%)',
                boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
                backdropFilter: 'blur(12px)',
              },
            }}
          >
            <Box display="flex" justifyContent="space-between" alignItems="center" p={2}>
              <Typography variant="h5" sx={{ color: '#fff', fontWeight: 'bold' }}>
                ADMINIS
              </Typography>
              <IconButton onClick={handleDrawerToggle} sx={{ color: '#fff' }}>
                <MenuOutlinedIcon />
              </IconButton>
            </Box>
            {sidebarContent}
          </Drawer>
        </>
      )}
    </>
  );
};

export default Sidebar;